module.exports = __webpack_public_path__ + "static/sm-c4ee42b3c4beaeb81088bc5ceba19de8.svg";